import Immutable from "immutable";
import { Features } from "resourceModels/Client";
import { getResource } from "selectors/resources";
import BaseMessageRecord, {
  BaseMessageRecordAttributes,
  BlockConfigGetter
} from "../BaseMessageRecord";

interface AuthMessageRecordAttributes extends BaseMessageRecordAttributes {
  type: "sign_in",
  messageLead: string,
  authButtonLabel: string,
  authProvider: string,
  errorResponseId: string
}

class AuthMessageRecord extends BaseMessageRecord<AuthMessageRecordAttributes>({
  type: "sign_in",
  messageLead: "To do this, I'll need you to sign in with the button below",
  authButtonLabel: "Sign In",
  authProvider: "",
  errorResponseId: null
}) {
  static blockConfig: BlockConfigGetter = (state) => {
    const client = getResource(state, "client");
    const { auths } = state;

    return ({
      blockType: "action",
      isVisible: (
        !client.hasFeature(Features.ZENDESK_CLIENT) &&
        !client.hasFeature(Features.LIVEPERSON_CLIENT) &&
        client.hasFeature(Features.PERSONALIZATION) &&
        (Boolean(auths.size) || client.hasFeature(Features.AUTHENTICATION))
      ),
      blockName: "Request Sign In",
      blockTitle: "Request Sign In",
      shortTitle: "Sign In",
      icon: "SignIn2"
    });
  };
}

/**
 * Validation
 */

AuthMessageRecord.getInvalidFields = (message: AuthMessageRecord): Immutable.List<string> => {
  const invalidFields: Set<string> = new Set();

  if (!message.messageLead) {
    invalidFields.add("messageLead");
  }

  if (!message.authButtonLabel) {
    invalidFields.add("authButtonLabel");
  }

  if (!message.authProvider) {
    invalidFields.add("authProvider");
  }

  if (!message.errorResponseId) {
    invalidFields.add("errorResponseId");
  }

  return Immutable.List(invalidFields);
};

export default AuthMessageRecord;
